import { render, staticRenderFns } from "./ServiceActions.vue?vue&type=template&id=048c7868&"
import script from "./ServiceActions.vue?vue&type=script&lang=js&"
export * from "./ServiceActions.vue?vue&type=script&lang=js&"
import style0 from "./ServiceActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports